<template>
  <div class="columns is-gapless is-mobile">
    <template v-if="!editMode">
      <div
        :class="dragHandleClass"
        class="column is-narrow scoped-drag-handle">
        <span class="handle-padding">
          <i class="fas fa-ellipsis-v fa-lg" />
          <i class="fas fa-ellipsis-v fa-lg" />
        </span>
      </div>
      <div class="column is-narrow">
        <b-checkbox v-model="checkedProxy">
        </b-checkbox>
      </div>
      <div class="column">
          <span @click.prevent="descriptionClicked" aria-role="button" class="item-description">{{item.description}}</span>
          <template v-if="foodItemName">
            <div>
              <a
                role="button"
                class="is-size-7"
                @click.prevent="routeFoodItem({ type: 'Recipe', id: item.foodItemId })">
                {{foodItemName}}
              </a>
            </div>
          </template>
      </div>
      <div class="column is-narrow">
        <span class="is-pulled-right">
          <button class="button is-white" @click="enterEdit">
            <b-icon
              pack="fas"
              icon="pencil-alt"
              size="is-small" />
          </button>
          <button class="button is-white" @click="$emit('delete')">
            <b-icon
              pack="fas"
              icon="trash-alt"
              size="is-small" />
          </button>
        </span>
      </div>
    </template>
    <template v-else>
      <div class="column is-narrow">
        <span class="handle-padding">
          <i class="fas fa-ellipsis-v fa-lg" />
          <i class="fas fa-ellipsis-v fa-lg" />
        </span>
      </div>
      <div class="column">
        <div class="field">
          <!-- can't use buefy input if we want to setSelectionRange -->
          <div class="control">
            <input
              class="input"
              type="text"
              ref="input"
              v-model="newDescription"
              :placeholder="item.description"
              @keyup.enter="completeEdit"
              @keyup.esc="cancelEdit">
          </div>
        </div>
      </div>
      <div class="column is-narrow">
        <span class="is-pulled-right">
          <button class="button is-white" @click="completeEdit">
            <b-icon
              pack="fas"
              icon="check"
              size="is-small" />
          </button>
          <button class="button is-white" type="reset" @click="editMode = false">
            <b-icon
              pack="fas"
              icon="times"
              size="is-small" />
          </button>
        </span>
      </div>
    </template>
  </div>
</template>

<script>
import routingMixin from '../../mixins/routing';

export default {
  name: 'shoppingListItem',
  mixins: [routingMixin],
  props: ['item', 'checked', 'dragHandleClass'],
  data() {
    return {
      // Used to cause the check/uncheck to actually display before the item
      // transitions to the other list when user clicks the description
      checkedOverride: null,
      grabbing: false,
      editMode: false,
      newDescription: '',
    };
  },
  computed: {
    foodItemName() {
      return this.$store.getters['shoppingList/foodItemName'](this.item.foodItemId);
    },
    checkedProxy: {
      get() {
        return (this.checkedOverride !== null ? this.checkedOverride : this.checked);
      },
      set(value) {
        // Allow for the checkbox to render the check/uncheck if the description was clicked
        this.$nextTick(() => this.$emit('checkbox', value));
      },
    },
  },
  methods: {
    descriptionClicked() {
      this.checkedOverride = !this.checked;
    },
    enterEdit() {
      this.newDescription = this.item.description;
      this.editMode = true;
      this.$nextTick(() => {
        const input = this.$refs.input;
        input.focus();
        input.setSelectionRange(this.newDescription.length, this.newDescription.length);
      });
    },
    completeEdit() {
      if (this.newDescription !== this.item.description) {
        this.$emit('change', this.newDescription);
      }

      this.editMode = false;
    },
    cancelEdit() {
      this.editMode = false;
    },
  },
};
</script>

<style lang="sass" scoped>
.item-description
  cursor: pointer 

.scoped-drag-handle
  cursor: grab

.handle-padding
  padding-right: 20px

</style>



// WEBPACK FOOTER //
// src/components/shopping-list/ShoppingListItem.vue